var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08333 25C1.52778 25 1.04167 24.7917 0.625 24.375C0.208333 23.9583 0 23.4722 0 22.9167V2.08333C0 1.52778 0.208333 1.04167 0.625 0.625C1.04167 0.208333 1.52778 0 2.08333 0H11.7708V2.08333H2.08333V22.9167H22.9167V13.2292H25V22.9167C25 23.4722 24.7917 23.9583 24.375 24.375C23.9583 24.7917 23.4722 25 22.9167 25H2.08333ZM9.09722 17.3958L7.63889 15.9028L21.4583 2.08333H13.8542V0H25V11.1458H22.9167V3.57639L9.09722 17.3958Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.229f4a77091d85b85b5941c6455db56a.svg";
export { ForwardRef as ReactComponent };